export function getCountryCodeFromPath() {
    if (typeof window !== "undefined") {
        return window.location.pathname.startsWith("/in") ? "IN" : "UAE";
    }

    return "UAE";
}

export function isIndianUser() {
    return getCountryCodeFromPath() === "IN";
}

export function isNonIndianUser() {
    return getCountryCodeFromPath() !== "IN";
}
